
export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.mixin({
        data () {
            return {
                required: value => !!value || this.$t('edit.fieldmandatory'),
                required0: value => (value !== undefined && value !== null) || this.$t('edit.fieldmandatory')
            }
        },
        methods: {
            accentlessFiltering (itemText, queryText) {
                if (!itemText || typeof itemText !== 'string') {
                    return false
                }
                return (
                    itemText
                        .normalize('NFD')
                        .replace(/[\u0300-\u036F]/g, '')
                        .toLowerCase()
                        .indexOf(queryText.toLowerCase()) === 0
                )
            },
            accentlessFilteringContains (itemText, queryText ) {
                if (!itemText || typeof itemText !== 'string') {
                    return false
                }
                return (
                    itemText
                        .normalize('NFD')
                        .replace(/[\u0300-\u036F]/g, '')
                        .toLowerCase()
                        .includes(queryText.toLowerCase())
                )
            }
        }
    })
})
